import 'bootstrap/dist/css/bootstrap.css';
import React, { useState } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import configureStore from './store/configureStore';
import {App} from './App';
import './i18n';
import register from './registerServiceWorker';
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import { syncHistoryWithStore } from 'react-router-redux'
import { Offline as OfflineIntegration } from "@sentry/integrations";
import { createRoot } from 'react-dom/client';
// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');

// Get the application-wide store instance, prepopulating with state from the server where available.
const browserHistory = createBrowserHistory({ basename: baseUrl });
const initialState = window.initialReduxState;
export const store = configureStore(browserHistory, initialState);
const rootElement = document.getElementById('root');
const history = syncHistoryWithStore(browserHistory, store)

Sentry.init({
  dsn: "https://b11eae9b4027417b999261d06c7af885@o1048187.ingest.sentry.io/6025371",
  integrations: [new Integrations.BrowserTracing(), new OfflineIntegration()],
  autoSessionTracking: true,
  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0,
});

export const ApplicationContext = React.createContext();

const AppContext = ({ ...props }) => {
  const [appState, setAppState] = useState({});

  return (
    <ApplicationContext.Provider value={[appState, setAppState]}>
      <Router history={history}>
          <App />
      </Router>
    </ApplicationContext.Provider>
  )
}
const root = createRoot(rootElement);
root.render(
    <Provider store={store}>
      <AppContext />
    </Provider>
)

register();
